import "core-js/modules/es.string.sub.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.topNoticeShow ? _c("div", {
    staticClass: "noticeBox",
    style: {
      color: _vm.formData.textColor,
      backgroundColor: _vm.formData.bgColor,
      cursor: _vm.formData.pathLink ? "pointer" : "default"
    },
    on: {
      click: _vm.jumpTo
    }
  }, [_vm.formData.main.title[_vm.defaultLangId] ? _c("div", {
    staticClass: "noticeTitle"
  }, [_c("span", {
    style: {
      fontSize: _vm.formData.main.fontSize + "px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.main.title[_vm.defaultLangId]) + " ")]), _c("svg", {
    staticClass: "icon del",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.closeNotice.apply(null, arguments);
      }
    }
  }, [_c("use", {
    attrs: {
      "xlink:href": "#icon-a-16-Delete"
    }
  })])]) : _vm._e(), _vm.formData.sub.title[_vm.defaultLangId] ? _c("div", {
    staticClass: "noticeContent"
  }, [_c("span", {
    style: {
      fontSize: _vm.formData.sub.fontSize + "px"
    }
  }, [_vm._v(_vm._s(_vm.formData.sub.title[_vm.defaultLangId]))])]) : _vm._e()]) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };